// Fetch order data
export async function fetchDBOrder() {
  try {
    const response = await fetch('/api/db/orders');
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching order data:', error);
    return {
      error: error.message
    };
  }
}
// Create new order
export async function createTDBOrder(newOrder) {
  try {
    const response = await fetch('/api/db/orders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newOrder)
    });
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error creating order:', error);
    return {
      error: error.message
    };
  }
}
// Update existing order
export async function updateTDBOrder(updatedOrder) {
  try {
    const response = await fetch('/api/db/orders', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedOrder)
    });
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error updating order:', error);
    return {
      error: error.message
    };
  }
}